import {
  SET_SIDEBAR_CLOSE,
  SET_ACTIVE_TAB,
  SET_SCROLL_POSITION,
  useVideoUI,
  useVideoUIDispatch,
} from "../../VideoUIContext";
import { VideoUIActiveTab } from "../../videoUI.types";
import VideoUISidebar from "./VideoUISidebar";
import type { Action } from "@core/features/actions";
import { useChatUnreadCount } from "@core/features/chat";
import { useFetchUserCircles } from "@core/features/circle";
import { usePlatformStore } from "@platform/store";

export type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptAction: Action | null;
};

export function VideoUISidebarContainer({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptAction,
}: Props) {
  const dispatch = useVideoUIDispatch();

  const { activeTab, scrollPositions } = useVideoUI();

  const unreadCount = useChatUnreadCount();
  const user = usePlatformStore((s) => s.user);
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;

  const handleClose = () => {
    dispatch({ type: SET_SIDEBAR_CLOSE });
  };

  const handleTabChange = (tab: VideoUIActiveTab) => {
    dispatch({ type: SET_ACTIVE_TAB, payload: { activeTab: tab } });
  };

  const handleScrollPositionSave = (
    tab: VideoUIActiveTab,
    position: number
  ) => {
    dispatch({ type: SET_SCROLL_POSITION, payload: { tab, position } });
  };

  return (
    <VideoUISidebar
      activeTab={activeTab}
      scrollPositions={scrollPositions}
      priorityBasedPolicy={priorityBasedPolicy}
      sharingAttendeeId={sharingAttendeeId}
      onClose={handleClose}
      onTabChange={handleTabChange}
      onScrollPositionSave={handleScrollPositionSave}
      meetingScriptAction={meetingScriptAction}
      unreadCount={unreadCount}
      userCircles={userCircles}
    />
  );
}

export default VideoUISidebarContainer;
